import { render, staticRenderFns } from "./ROIFilterBox.vue?vue&type=template&id=388cc258&scoped=true&"
import script from "./ROIFilterBox.vue?vue&type=script&lang=js&"
export * from "./ROIFilterBox.vue?vue&type=script&lang=js&"
import style0 from "./ROIFilterBox.vue?vue&type=style&index=0&lang=less&"
import style1 from "./ROIFilterBox.vue?vue&type=style&index=1&id=388cc258&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "388cc258",
  null
  
)

export default component.exports